/**
 * BHT One — hospitality photography library.
 *
 * All URLs point to user-provided artifact photos of real hospitality scenes
 * with the BHT One interface subtly integrated. Consistent warm cinematic
 * grading; the employee is always the visual hero (per Brand Bible §17).
 *
 * When we replace stock with our own hotel-shoot, only this file changes.
 */

export const PHOTO_RECEPTION =
  "https://customer-assets-v7afamib.emergentagent.net/job_bht-one-preview/artifacts/1ym6qn7x_receptie%20%28hero%29%20foto.png";

export const PHOTO_HOUSEKEEPING =
  "https://customer-assets-v7afamib.emergentagent.net/job_bht-one-preview/artifacts/72juh6xw_housekeeping%20foto.png";

export const PHOTO_MANAGER =
  "https://customer-assets-v7afamib.emergentagent.net/job_bht-one-preview/artifacts/no4geof2_manager%20foto.png";

export const PHOTO_KITCHEN =
  "https://customer-assets-v7afamib.emergentagent.net/job_bht-one-preview/artifacts/9gc6vjar_restaurant%20%28keuken%29.png";

export const PHOTO_TECHNICAL =
  "https://customer-assets-v7afamib.emergentagent.net/job_bht-one-preview/artifacts/si815mj4_technise%20dienst%20afbeelding.png";

export const PHOTO_MARKETING =
  "https://customer-assets-v7afamib.emergentagent.net/job_bht-one-preview/artifacts/g7ydnq61_marketing%20en%20sales%20.png";

export const PHOTO_RESTAURANT =
  "https://customer-assets-v7afamib.emergentagent.net/job_bht-one-preview/artifacts/mq22tpn6_restaurant.png";
